<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="24" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.package.Name')" prop="skuName">
              <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.Name')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.package.SKU')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.SKU')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.package.Barcode')" prop="barCode">
              <BjInput v-model="queryParams.barCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.Barcode')" clearable @keyup.enter.native="handleQuery"/>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.package.Method')" prop="packingMethod">
              <BjSelectLov v-model="queryParams.packingMethod" :placeholder="$t('goodsPage.package.Method')" :option-list="MethodOption" />
            </el-form-item>
          </el-col> -->
          <el-col :span="colSpan" v-if="!$store.getters.cusId">
            <el-form-item :label="$t('goodsPage.package.Type')" prop="packageType">
              <BjSelectLov v-model="queryParams.packageType" :placeholder="$t('goodsPage.package.Type')" :option-list="TypeOption" />
            </el-form-item>
          </el-col>
          <el-col v-if="!$store.getters.cusId&&queryParams.packageType=='cus'" :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('billingPage.CustomerName')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
            <el-button type="primary"  @click="onImport">{{ $t('importText') }}</el-button>
            <el-button type="primary" class="main-btn" @click="onExport">{{ $t('exportText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <!-- <template v-else-if="col.prop == 'packingMethod'">{{ MethodOption.bjGet(scope.row.packingMethod) }}</template> -->
                <template v-else-if="col.prop == 'packageType'">{{ TypeOption.bjGet(scope.row.packageType) }}</template>
                <!-- 价格 显示 -->
                <span v-else-if="col.prop.toLocaleLowerCase().includes('price')">{{ $number2money(scope.row[col.prop]) }}</span>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button :disabled="$store.getters.cusId&&props.row.packageType=='csg'" type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onBindSKU(props.row)">{{ $t('goodsPage.package.bindSKU') }}</el-button>
                <!-- <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button> -->
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 绑定sku -->
      <drawerData ref="drawerData" @reFresh="reFresh"/>
      <!-- 导入弹窗 -->
      <ExcelImportDialog ref="ExcelImport" @submit="handleQuery" />
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" :customer-list="customerList" @handleConfirm="handleConfirm" />
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { goodsApi } from '@/api';
  import papa from 'papaparse';
  import ExcelImportDialog from './ExcelImportDialog.vue';
  import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
  import DataForm from './components/DataForm.vue';
  import drawerData from './components/drawerData';
  
  export default {
    name: 'BusinessGoodsPackageManagement',
    components: {
      ExcelImportDialog,
      DataForm,
      drawerData,
    //   skuRule,
      BjSelectCustomer
    },
    mixins: [pageMiXin],
    props: {
      setFlag: {
        type: [String, Number],
        default: null,
      },
    },
    data() {
      return {
        colSpan: 4,
        queryApi: goodsApi.getSkuPage,
        queryParamsUser: {
          skuName: null,
          skuCode: null,
          barCode: null,
          // packingMethod: null,
          // packageType: 'cus',
          cusId: this.$store.getters?.cusId,
          itemType: 'package box',
          // selectType 包材的话传2，商品传1
          selectType: 2,
        },
        queryParamsAdmin: {
          skuName: null,
          skuCode: null,
          barCode: null,
          // packingMethod: null,
          packageType: null,
          cusId: null,
          itemType: 'package box',
          // selectType 包材的话传2，商品传1
          selectType: 2,
        },
        MethodOption: [
          { label: this.$t('goodsPage.package.order'), value: 'order' },
          { label: this.$t('goodsPage.package.product'), value: 'product' },
        ],
        TypeOption: [
          { label: this.$t('goodsPage.package.csg'), value: 'csg' },
          { label: this.$t('goodsPage.package.cus'), value: 'cus' },
        ],
        labelList1: [
          { label: this.$t('goodsPage.package.Name'), prop: 'skuName', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.SKU'), prop: 'skuCode', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('goodsPage.package.Barcode'), prop: 'barCode', isCheck: true, disabled: false, width: 125 },
          // { label: this.$t('goodsPage.package.Method'), prop: 'packingMethod', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.Type'), prop: 'packageType', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.Supplier'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('goodsPage.package.Cost'), prop: 'costPrice', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.Price'), prop: 'salesPrice', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.num'), prop: 'quantity', isCheck: true, disabled: false,},
          { label: this.$t('goodsPage.package.Length'), prop: 'length', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Width'), prop: 'width', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Height'), prop: 'height', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Weight'), prop: 'weight', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 153 },
        ],
        labelList2: [
          { label: this.$t('goodsPage.package.Name'), prop: 'skuName', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.SKU'), prop: 'skuCode', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('goodsPage.package.Barcode'), prop: 'barCode', isCheck: true, disabled: false, width: 125 },
          // { label: this.$t('goodsPage.package.Method'), prop: 'packingMethod', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.Type'), prop: 'packageType', isCheck: true, disabled: false, width: '150' },
          // { label: this.$t('goodsPage.package.Supplier'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          // { label: this.$t('goodsPage.package.Cost'), prop: 'costPrice', isCheck: true, disabled: false, width: '150' },
          // { label: this.$t('goodsPage.package.Price'), prop: 'salesPrice', isCheck: true, disabled: false, width: '150' },
          { label: this.$t('goodsPage.package.num'), prop: 'quantity', isCheck: true, disabled: false,},
          { label: this.$t('goodsPage.package.Length'), prop: 'length', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Width'), prop: 'width', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Height'), prop: 'height', isCheck: true, disabled: false },
          { label: this.$t('goodsPage.package.Weight'), prop: 'weight', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 153 },
        ],
      };
    },
    computed: {
      queryParams() {
        return this.$store.getters?.cusId ? this.queryParamsUser : this.queryParamsAdmin;
      },
      labelList() {
        return this.$store.getters?.cusId ? this.labelList2 : this.labelList1;
      },
    },
    methods: {
      onBindSKU(row) {
        this.$refs.drawerData.drawer = true;
        this.$refs.drawerData.form.giftRules = {
          activityPrice: row.activityPrice,
          fullNum: row.fullNum,
          giftCondition: row.giftCondition,
          giftNum: row.giftNum,
          packageType: row.packageType,
          salesPrice: row.salesPrice,
          skuCode: row.skuCode,
          skuName: row.skuName,
          tenantId: row.tenantId,
        };
        this.$refs.drawerData.getData();
      },
      /** 新建 */
      onAdd() {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.pageType = 'add';
      },
      onExport() {
        const fileName = `Package List`;
        if (!this.selectedRows.length) return this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        let csvData = [];
        this.selectedRows.forEach(async (item) => {
          csvData.push({
            'Package Name': item.skuName,
            'Package SKU': item.skuCode,
            'Package Barcode': item.barCode,
            // 'Packing Method': this.MethodOption.bjGet(item.packingMethod),
            'Package Type': this.TypeOption.bjGet(item.packageType),
            'Supplier':this.customerList.bjGet(item.cusId),
            'Package Cost': item.costPrice.toFixed(2),
            'Package Price': item.salesPrice.toFixed(2),
            // 'Package Fee': item.clearingPrice.toFixed(2),
            'Length(CM)': item.length,
            'Width(CM)': item.width,
            'Height(CM)': item.height,
            'Weight(KG)': item.weight,
          });
        });
        csvData.forEach(item => {
          if (this.$store.getters?.cusId) {
            delete item['Supplier'];
            delete item['Package Cost'];
            delete item['Package Price'];
            // delete item['Package Fee'];
          }
        });
        setTimeout(() => {
          if (!csvData.length) return;
          const csv = papa.unparse(csvData);
          const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const csvURL = window.URL.createObjectURL(data);
          const download = document.createElement('a');
          download.href = csvURL;
          download.setAttribute('download', fileName);
          download.click();
          csvData = null;
        }, 1000);
      },
      onImport() {
        this.$refs.ExcelImport.show();
      },
  
      /** 查看 */
      onView(row) {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.pageType = 'view';
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(row));
      },
      /** 编辑操作 */
      onEdit(row) {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.pageType = 'edit';
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(row));
      },
      // 子页面回调执行  '新增'  或者 '编辑' 方法
      handleConfirm(handleForm) {
        // 判断逻辑 ==> id存在就是编辑，否则就是新增
        if (handleForm.id) {
          goodsApi.upSkuPage({
            cusId: handleForm.cusId,
            flag: false,
            sku:handleForm,
          }).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.$refs.DataForm.handleClose();
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        } else {
          goodsApi.addSkuPage({
            cusId: handleForm.cusId,
            flag: false,
            setFlag: 0,
            skuList:[handleForm]
          }).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.$refs.DataForm.handleClose();
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        }
      },
      // 行内删除按钮
      // onDel(row) {
      //   this.$confirm(`${this.$t('goodsAudit.Ps1')} ${row.standardSkuCode}，${this.$t('goodsAudit.Ps2')}?`, this.$t('toast.hintText'), {
      //     confirmButtonText: this.$t('toast.okText'),
      //     cancelButtonText: this.$t('toast.cancelText'),
      //     type: 'warning',
      //   }).then(() => {
      //     const API_DATA = {
      //       setFlag: row.setFlag,
      //       skuList: [row.skuCode],
      //     };
      //     this.deleteApi(API_DATA);
      //   });
      // },
      // deleteApi(API_DATA) {
      //   goodsApi.delSkulist(API_DATA).then(res => {
      //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //       this.$message.success(this.$t('toast.operationSuccessText'));
      //       setTimeout(() => {
      //         this.reFresh();
      //       }, 500);
      //     }
      //   });
      // },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams = this.$store.getters?.cusId ? this.queryParamsUser : this.queryParamsAdmin;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style scoped>
  /* ::v-deep .el-form-item__content {
    height: 29px !important;
  } */
  ::v-deep .bj-page .el-form-item__label {
    display: none;
  }
  </style>
  